<template>
  <div>
    <v-navigation-drawer
      permanent
      left
      app
      width="300"
      class="mt-12"
    >
      <v-list dense nav open-strategy="multiple">
        <v-list-item
          v-for="item in routes"
          :key="item.route"
          :to="baseRoute + '/' + item.route"
          exact
          :disabled="item.disabled"
        >
          <v-list-item-avatar>
            <v-icon>
              {{ item.icon }}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-title>
            {{ item.label }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="item.disabled">
            <v-chip x-small>
              Kommer snart
            </v-chip>
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      flat
      class="mt-12"
    >
      <v-btn
        text
        to="/admin/customers"
        exact
        class="mr-3"
      >
        <v-icon> mdi-arrow-left </v-icon>
      </v-btn>
      <v-app-bar-title>
        {{ customer?.title }}
      </v-app-bar-title>

      <v-progress-linear :active="loading" indeterminate absolute bottom></v-progress-linear>
    </v-app-bar>

    <div>
      <router-view
        v-if="customer"
        :customer="customer"
        @update="fetchData"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerDetail',
  data() {
    return {
      loading: true,
      customer: null,
      routes: [
        {
          label: 'Generelt',
          route: '',
          icon: 'mdi-home-outline'
        },
        {
          label: 'Lokationer',
          route: 'locations',
          icon: 'mdi-map-marker-multiple-outline'
        },
        {
          label: 'Afdelinger',
          route: 'departments',
          icon: 'mdi-sitemap'
        },
        {
          label: 'Workflow',
          route: 'workflow',
          icon: 'mdi-middleware-outline'
        },
        {
          label: 'Roller',
          route: 'roles',
          icon: 'mdi-badge-account-horizontal-outline'
        },
        {
          label: 'Varekategorier',
          route: 'part-categories',
          icon: 'mdi-shape-outline'
        },
        {
          label: 'Subject areas',
          route: 'subject-areas',
          icon: 'mdi-account-hard-hat'
        },
        {
          label: 'Opgavetyper',
          route: 'task-types',
          icon: 'mdi-format-list-bulleted-type'
        },
        {
          label: 'Aftaletyper',
          route: 'approval-types',
          icon: 'mdi-handshake-outline'
        }
      ]
    }
  },
  computed: {
    baseRoute() {
      return '/admin/customers/' + this.$route.params.customerId;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get('customers/' + this.$route.params.customerId);

        this.customer = data;
      } catch(error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>